"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfoBoxDetails = void 0;
const useSelector_1 = require("./useSelector");
const EMPTY_STATE = {
    controlsState: {
        enableIsolate: 0,
        faded: 0,
        fadingOthers: 0,
        hidden: 0,
        hidingOthers: 0,
    },
    identifier: '',
    isAudioPlaying: false,
    names: {
        title: '',
    },
};
function useInfoBoxDetails() {
    return (0, useSelector_1.useSelector)(state => (state === null || state === void 0 ? void 0 : state.details) || EMPTY_STATE);
}
exports.useInfoBoxDetails = useInfoBoxDetails;
